export enum CONTEXT_TYPES {
  ALTERNATIVES = 'ALTERNATIVES',
  BENCHMARK = 'BENCHMARK',
  EXPORT = 'EXPORT',
  FLOWMAP = 'FLOWMAP',
  GLOBAL = 'GLOBAL',
  REPORTING = 'REPORTING',
  TEMP = 'TEMP',
  VIEW = 'VIEW',
  DATASET = 'DATASET',
}

export enum FILTER_ACTION_TYPES {
  RESET_FILTERS = 'RESET_FILTERS',
  RESET_VIEW = 'RESET_VIEW',
  UPDATE = 'UPDATE',
  UPDATE_VIEW = 'UPDATE_VIEW',
  UPDATE_VIEW_FILTERS = 'UPDATE_VIEW_FILTERS',
  UPDATE_FILTER_OPTIONS = 'UPDATE_FILTER_OPTIONS',
}
